import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff, Lock, User } from "lucide-react";

function Login() {
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");

    const handleLogin = (e) => {
        e.preventDefault();
        setError("");

        if (username === "superadmin" && password === "123456") {
            localStorage.setItem("jodiPointRole", "SUPER_ADMIN");
            localStorage.setItem("jodiPointUser", "Super Admin");

            navigate("/super-admin/dashboard");
            return;
        }

        if (username === "branchadmin" && password === "123456") {
            localStorage.setItem("jodiPointRole", "BRANCH_ADMIN");
            localStorage.setItem("jodiPointUser", "Branch Admin");

            navigate("/branch/dashboard");
            return;
        }

        setError("Invalid username or password");
    };

    return (
        <div className="login-page">

            <div className="login-container">

                {/* LEFT BRANDING */}
                <div className="login-brand">

                    <div className="brand-logo">
                        <img
                            src="/logo.png"
                            alt="Jodi Point"
                        />
                    </div>

                    <div className="brand-content">
                        <span className="brand-small-title">
                            JODI POINT MATRIMONIAL SERVICES
                        </span>

                        <h1>
                            Bringing hearts
                            <br />
                            together.
                        </h1>

                        <p>
                            Manage members, matrimonial profiles,
                            branches, memberships and matches from
                            one powerful platform.
                        </p>
                    </div>

                    <div className="brand-footer">
                        © 2026 Jodi Point. All rights reserved.
                    </div>

                </div>

                {/* LOGIN */}
                <div className="login-form-section">

                    <div className="login-box">

                        <div className="mobile-logo">
                            <img
                                src="/logo.png"
                                alt="Jodi Point"
                            />
                        </div>

                        <h2>Welcome Back</h2>

                        <p className="login-subtitle">
                            Sign in to your admin account
                        </p>

                        <form onSubmit={handleLogin}>

                            {/* USERNAME */}
                            <div className="form-group">

                                <label>Username</label>

                                <div className="input-wrapper">

                                    <User size={19} />

                                    <input
                                        type="text"
                                        placeholder="Enter username"
                                        value={username}
                                        onChange={(e) =>
                                            setUsername(e.target.value)
                                        }
                                    />

                                </div>

                            </div>

                            {/* PASSWORD */}
                            <div className="form-group">

                                <label>Password</label>

                                <div className="input-wrapper">

                                    <Lock size={19} />

                                    <input
                                        type={
                                            showPassword
                                                ? "text"
                                                : "password"
                                        }
                                        placeholder="Enter password"
                                        value={password}
                                        onChange={(e) =>
                                            setPassword(e.target.value)
                                        }
                                    />

                                    <button
                                        type="button"
                                        className="password-toggle"
                                        onClick={() =>
                                            setShowPassword(!showPassword)
                                        }
                                    >
                                        {showPassword ? (
                                            <EyeOff size={19} />
                                        ) : (
                                            <Eye size={19} />
                                        )}
                                    </button>

                                </div>

                            </div>

                            {error && (
                                <div className="login-error">
                                    {error}
                                </div>
                            )}

                            <button
                                type="submit"
                                className="login-button"
                            >
                                Sign In
                            </button>

                        </form>

                        <div className="login-info">
                            Jodi Point Admin Portal
                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
}

export default Login;